/**
 * @fileoverview Textarea - Public API
 */
export { Textarea, type TextareaProps } from "./textarea";
